module.exports = __webpack_public_path__ + "media/features/use-cases/images/image_tablet_en-dd29bdcab5c9f07af5c9f3546dccba0c.png";